import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../../components/UI/ListLinkBox';
import { translate } from '../../../../utils/util';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS, ENUMS } from '../../../../utils/constants';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';
import * as actionsInventory from '../../../../actions/inventoryAction';

const InventoryGeneralHome = (props) => {
    const menu = () => {
        let menuItems = [];
        if (checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Operational : PERMISSIONS.Inventory.Rotative.Operational)
            && props.filter.statusInventory !== ENUMS.eInventoryLotStatus.Finished && props.filter.statusInventory !== ENUMS.eInventoryLotStatus.Canceled) {
            menuItems = [...menuItems, { route: 'filter', icon: 'mdi mdi-filter-variant', text: translate('inventory:general.menu.filter') }];
        }

        if (checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Supervisor : PERMISSIONS.Inventory.Rotative.Supervisor)
            || checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Audit : PERMISSIONS.Inventory.Rotative.Audit)
            || checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Operational : PERMISSIONS.Inventory.Rotative.Operational)) {
            menuItems = [...menuItems, { route: 'audit', icon: 'mdi mdi-text-box-search-outline', text: translate('inventory:general.menu.audit') }];
        }

        if (checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Supervisor : PERMISSIONS.Inventory.Rotative.Supervisor)
            || checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Operational : PERMISSIONS.Inventory.Rotative.Operational)) {
            menuItems = [...menuItems, { route: 'auditFull', icon: 'mdi mdi-text-box-search-outline', text: translate('inventory:general.menu.auditFull') }];
        }

        if (checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Supervisor : PERMISSIONS.Inventory.Rotative.Supervisor)) {
            menuItems = [...menuItems, { route: 'divergingItems', icon: 'mdi mdi-compare', text: translate('inventory:general.menu.divergingItems') }];
        }

        // if (checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Operational : PERMISSIONS.Inventory.Rotative.Operational)) {
        //     menuItems = [...menuItems, { route: 'drone', icon: 'mdi mdi-quadcopter', text: translate('inventory:general.menu.drone') }];
        // }

        if (checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Monitoring : PERMISSIONS.Inventory.Rotative.Monitoring)) {
            menuItems = [...menuItems, { route: 'monitoring', icon: 'mdi mdi-chart-bar-stacked', text: translate('inventory:general.menu.monitoring') }];
        }

        if (checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Supervisor : PERMISSIONS.Inventory.Rotative.Supervisor)
            || checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.Audit : PERMISSIONS.Inventory.Rotative.Audit)) {
            menuItems = [...menuItems, { route: 'qrcoderange', icon: 'mdi mdi-chart-bar-stacked', text: 'Range de Qr Code' }];
        }

        if (checkPermission(PERMISSIONS.Inventory.ReenvioSIM)) {
            menuItems = [...menuItems, {
                route: '../log',
                icon: 'mdi mdi-file-alert-outline',
                text: 'Logs Envio SIM',
                onClick: () => {
                    props.clearLogs();
                }
            }];
        }

        return menuItems;
    };

    const titleInventoryGeneralHome = { icon: "mdi mdi-clipboard-check-outline", label: translate('inventory', 'inventory') };

    const subtitlesInventoryGeneralHome = () => {
        return [{ icon: "mdi mdi-alpha-g-circle-outline", label: props.filter.typeInventory === 'G' ? translate('menu.general', 'inventory') : translate('menu.rotative', 'inventory') }];
    }

    return (
        <div>
            <Breadcrumbs id="inventoryGeneralHome" title={titleInventoryGeneralHome} subtitles={subtitlesInventoryGeneralHome()} />
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearLogs: () => {
            dispatch(actionsInventory.setLogs([]));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InventoryGeneralHome)));
